import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useLinkEditorStore = defineStore("linkEditor", () => {
  const linkEditors = ref(new Set<string>());
  function observeEditor(id: string) {
    linkEditors.value.add(id);

    return () => {
      linkEditors.value.delete(id);
    };
  }

  const isEditingLink = computed(() => linkEditors.value.size > 0);

  return {
    observeEditor,
    isEditingLink,
  };
});
